export const validateImage = (file: File) =>
    new Promise<boolean>((res, rej) => {
        const image = new Image();
        image.onload = () => {
            if (image.width < 800 || image.height < 600) res(false);
            else res(true);
        };
        image.onerror = rej;
        image.src = URL.createObjectURL(file);
    });
